import { Link } from "react-router-dom";

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  secondaryLink?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel = "返回首页",
  secondaryLink = "/",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-200 bg-background-100/60 px-6 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-background-200/70 text-2xl text-foreground-400">
        <i className="ri-search-eye-line" />
      </div>
      <h3 className="text-base font-semibold text-foreground-950 md:text-lg">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-600">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className="rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            {actionLabel}
          </button>
        ) : null}
        <Link
          to={secondaryLink}
          className="rounded-md border border-background-200 bg-background-50 px-5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          {secondaryLabel}
        </Link>
      </div>
    </div>
  );
}